/***************************************************************************/
"use client";
/***************************************************************************/

import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";
import { cn } from "../../../utils/css";
import { Label } from "../label";
import { useFormField } from "./form-field";

const FormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { error, formItemId } = useFormField();

  return (
    <Label
      ref={ref}
      className={cn("font-medium", error && "text-error", className)}
      htmlFor={formItemId}
      {...props}
    />
  );
});
FormLabel.displayName = "FormLabel";

export { FormLabel };
